<template>
  <svg width="13" height="20" viewBox="0 0 13 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M4.31325 19.9735L4.28471 11.2467H0.551025V7.50656H4.28471V5.01316C4.28471 1.64807 6.36501 0.0263672 9.36176 0.0263672C10.7972 0.0263672 12.0309 0.133421 12.3905 0.181269V3.69798L10.3121 3.69893C8.68229 3.69893 8.36672 4.47471 8.36672 5.61312V7.50656H12.9967L11.7521 11.2467H8.3667V19.9735H4.31325Z"
        :fill="color" />
  </svg>
</template>

<script>
export default {
  name: 'FacebookIcon',
  props: {
    color: {
      type: String,
      default: 'white',
    },
  },
};
</script>